import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import countryList from "react-select-country-list";
import { FiEdit } from "react-icons/fi";

const AccountInfo = () => {
  const user = useSelector((state) => state.user.user);
  const navigate = useNavigate();
  const countries = countryList().getData();

  if (!user) {
    return <p className="text-gray-500 text-center py-6">Loading...</p>;
  }

  const formatDate = (timestamp) => {
    if (!timestamp) return "-";
    try {
      const date = new Date(timestamp);
      return date.toLocaleDateString("en-MY", {
        year: "numeric",
        month: "long",
        day: "numeric",
      });
    } catch {
      return timestamp;
    }
  };

  const hasRole = (u, roleName) => {
    if (!u?.role) return false;
    if (Array.isArray(u.role)) return u.role.includes(roleName);
    return u.role === roleName;
  };

  return (
    <div className="space-y-6">

      {/* CARD */}
      <div className="relative bg-white rounded-xl shadow p-6 border border-gray-100">

        {/* TOP-RIGHT EDIT BUTTON */}
        <button
          onClick={() => navigate("/edit-profile")}
          className="absolute right-4 top-4 text-gray-500 hover:text-blue-600 transition"
        >
          <FiEdit size={22} />
        </button>

        {/* GRID INFO */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mt-2">

          <InfoItem label="Email" value={user.email} />

          <InfoItem label="Date of Birth" value={user.dob} />

          <InfoItem label="Phone" value={user.phone} />

          <InfoItem label="Gender" value={user.gender} />

          <InfoItem
            label="Country"
            value={
              user.country
                ? (countries.find((opt) => opt.value === user.country)?.label ||
                    user.country)
                : "-"
            }
          />
          
          <InfoItem label="Member Since" value={formatDate(user.createdAt)} />

          {hasRole(user, "player") && (
            <>
              <InfoItem label="Subscription Plan" value={user.plan} />

              <InfoItem
                label="Plan Expiry"
                value={
                  user.plan === "Free"
                    ? "-"
                    : formatDate(user.plan_expires_at)
                }
              />
            </>
          )}

          <InfoItem label="WSF SPIN" value={user.wsfSpin || "-"} />

          <InfoItem
            label="SPIN Expiry"
            value={
              user.wsfExpiry
                ? formatDate(user.wsfExpiry)
                : "-"
            }
          />

          <InfoItem
            label="Role"
            value={
              Array.isArray(user.role)
                ? user.role.map((r) => r.charAt(0).toUpperCase() + r.slice(1)).join(", ")
                : user.role
                ? user.role.charAt(0).toUpperCase() + user.role.slice(1)
                : "-"
            }
          />

          {hasRole(user, "player") && (
            <InfoItem label="Coach" value={user.coachName || "-"} />
          )}

        </div>
      </div>
    </div>
  );
};

/* SMALL INFO DISPLAY COMPONENT */
const InfoItem = ({ label, value }) => {
  return (
    <div className="flex flex-col">
      <span className="text-gray-500 text-sm font-medium">{label}</span>
      <span className="text-gray-800 font-semibold mt-0.5">
        {value || "-"}
      </span>
    </div>
  );
};

export default AccountInfo;
